import React, { useEffect, useState } from 'react';
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import Table, {
	dateFormatter,
	buttonsStyle
} from '../../../components/tables/table';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import { getEquipments, deleteEquipment, changeStatusEquipment } from '../../../../api/equipment';
import { Button, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { alertError, alertSuccess } from '../../../../utils/logger';
import { useHistory } from 'react-router-dom';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import { shallowEqual, useSelector } from 'react-redux';
import { getNonEmpty } from '../../../../utils/helpers';
import { SERVER_URL } from '../../../../api';
import PreviewDialog from '../../../components/dialogs/PreviewDialog';

function getData(equipments) {
	let data = [];
	for (let i = 0; i < equipments.length; ++i) {
		const elem = {};
		elem.img = equipments[i].iconURL;
		elem.name = getNonEmpty(equipments[i].fullName);
		elem.createdAt = equipments[i].createdAt;
		elem.id = equipments[i]._id;
		elem.active = equipments[i].active;
		data = data.concat(elem);
	}
	return data;
}

export default function EquipmentsPage() {
	const [data, setData] = useState([]);
	const [equipmentId, setEquipmentId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const [openPreviewDialog, setOpenPreviewDialog] = useState(false)
	const [previewImage, setPreviewImage] = useState(null)
	const history = useHistory();
	const user = useSelector((store) => store.authentication?.user, shallowEqual)

	function imageFormatter(cell) {
		return (cell && cell !== '') ? (
		  <img 
			src={SERVER_URL + '/' + cell} 
			alt="equipment" 
			style={{ width: '50px', height: '50px' }} 
			onClick={() => {
			  setPreviewImage(cell)
			  setOpenPreviewDialog(true)
			}}/>
		) : (
		  <div/>
		);
	  }

	function buttonFormatter(cell) {
		const elem = data.find(item => item.id === cell)
		return (
			<>
				<Tooltip title='Edit'>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => history.push('/edit-equipment/' + cell)}>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes('admin') && <>
					<Tooltip title={elem?.active ? "Disable" : "Enable"}>
						<Button
							style={buttonsStyle} size="small"
							onClick={() => {
								setEquipmentId(elem)
								setOpenConfirmDialog(1)
							}}>
							{elem?.active ? <ToggleOffIcon/> : <ToggleOnIcon style={{ color: 'red' }} />}
						</Button>
					</Tooltip>
					<Tooltip title='Delete'>
						<Button
							style={buttonsStyle}
							size='small'
							onClick={() => {
								setEquipmentId(cell);
								setOpenConfirmDialog(2);
							}}>
							<DeleteIcon />
						</Button>
					</Tooltip>
				</>}
			</>
		);
	}

	const columns = [
		{ dataField: 'img', text: 'Icon', sort: false, formatter: imageFormatter },
		{ dataField: 'name', text: 'Full name', sort: true },
		{
			dataField: 'createdAt',
			text: 'Created at',
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: 'id', text: '', formatter: buttonFormatter },
	];

	useEffect(() => {
		getEquipments()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({ error: error, customMessage: 'Could not get equipments.' });
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title='Equipments list'>
					<CardHeaderToolbar>
						<button
							type='button'
							className='btn btn-primary'
							onClick={() => history.push('/edit-equipment')}>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<PreviewDialog
						title={'Preview icon'}
						open={openPreviewDialog}
						setOpen={setOpenPreviewDialog}
						src={previewImage ? `${SERVER_URL}/${previewImage}` : null}
					/>
					<ConfirmDialog
						title={`Are you sure you want to ${equipmentId?.active ? 'disable' : 'enable'} this equipment?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusEquipment(equipmentId.id, !equipmentId?.active)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({ title: `${equipmentId?.active ? 'Disabled!' : 'Enabled!'}`, customMessage: `Equipment ${equipmentId?.active ? 'disabled' : 'enabled'} successfully` })
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({ error: error, customMessage: `Could not ${equipmentId?.active ? 'disable' : 'enable'} equipment.` })
								});
						}}
					/>
					<ConfirmDialog
						title={'Are you sure you want to remove this equipment?'}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteEquipment(equipmentId)
								.then((res) => {
									if (res.status === 204 || res.status === 200) {
										alertSuccess({
											title: 'Deleted!',
											customMessage: 'Equipment removed successfully.',
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: 'Could not remove equipment.',
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
